import * as React from 'react';
import { Responsive } from '@cian/ui-kit/responsive';

import { Valuation as ValuationDesktop } from './views/Desktop';
import { Valuation as ValuationMobile } from './views/Mobile';

export function Valuation() {
  return (
    <>
      <Responsive desktop>
        <ValuationDesktop />
      </Responsive>

      <Responsive tablet phone>
        <ValuationMobile />
      </Responsive>
    </>
  );
}
